import { render, staticRenderFns } from "./EmailsData.vue?vue&type=template&id=d0a2e2a8"
import script from "./EmailsData.vue?vue&type=script&lang=js"
export * from "./EmailsData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports